// generated by Copilot and not reviewed line by line

package com.huanshankeji.compose.material.icons.automirrored.filled

import com.huanshankeji.compose.material.icons.Icon
import com.huanshankeji.compose.material.icons.Icons

actual val Icons.AutoMirrored.Filled.ArrowBack: Icon get() = Icon("arrow_back")
actual val Icons.AutoMirrored.Filled.ArrowForward: Icon get() = Icon("arrow_forward")
actual val Icons.AutoMirrored.Filled.ExitToApp: Icon get() = Icon("exit_to_app")
actual val Icons.AutoMirrored.Filled.KeyboardArrowLeft: Icon get() = Icon("keyboard_arrow_left")
actual val Icons.AutoMirrored.Filled.KeyboardArrowRight: Icon get() = Icon("keyboard_arrow_right")
actual val Icons.AutoMirrored.Filled.List: Icon get() = Icon("list")
actual val Icons.AutoMirrored.Filled.Send: Icon get() = Icon("send")
